import React, { useState } from 'react'
import OrderDetails from './OrderDetails'
import {
  OrderStatus,
  OrderStatusMobile
} from '@/components/Account/MyOrders/OrderStatus'
import { useMediaQuery } from '@mui/material'
import theme from '@evocolabs/orkaui/lib/theme.cjs'

const MyOrders = () => {
  const [window, setWindow] = useState('status')
  const [index, setIndex] = useState(0)
  const useMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <div style={{ width: '100%' }}>
      {window === 'status' &&
        (useMobile ? (
          <OrderStatusMobile setWindow={setWindow} setIndex={setIndex} />
        ) : (
          <OrderStatus setWindow={setWindow} setIndex={setIndex} />
        ))}

      {window === 'orderDetail' && (
        <OrderDetails
          setWindow={setWindow}
          index={index}
          isQueryFromIndex={false}
        />
      )}
    </div>
  )
}

export default MyOrders
